import type { Icon as IconType } from '@rover/icons';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

import {
  BANNER_SEVERITY_ICONS,
  BannerSeverity,
  getBannerSeverityBackgroundColors,
  getBannerSeverityIconFillColors,
} from './BannerSeverity.constants';

export const getBackgroundColorForSeverity = (
  severity: BannerSeverity,
  theme: RoverTheme
): string => {
  const BANNER_SEVERITY_BACKGROUND_COLORS = getBannerSeverityBackgroundColors(theme);

  return (
    BANNER_SEVERITY_BACKGROUND_COLORS[severity] ??
    BANNER_SEVERITY_BACKGROUND_COLORS[BannerSeverity.INFO]
  );
};

export const getIconForSeverity = (severity: BannerSeverity): React.ComponentType<IconType> => {
  return BANNER_SEVERITY_ICONS[severity] ?? BANNER_SEVERITY_ICONS[BannerSeverity.INFO];
};

export const getIconFillColorForSeverity = (
  severity: BannerSeverity,
  theme: RoverTheme
): string => {
  const BANNER_SEVERITY_ICON_FILL_COLORS = getBannerSeverityIconFillColors(theme);
  return (
    BANNER_SEVERITY_ICON_FILL_COLORS[severity] ??
    BANNER_SEVERITY_ICON_FILL_COLORS[BannerSeverity.INFO]
  );
};
